// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../core/assets/fonts/OpenSans/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../core/assets/fonts/OpenSans/OpenSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../core/assets/fonts/OpenSans/OpenSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../core/assets/fonts/OpenSans/OpenSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../core/assets/fonts/OpenSans/OpenSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 400;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 500;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: 600;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: 700;
    font-display: swap;
}

@font-face {
    font-family: 'Open Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: 900;
    font-display: swap;
}

.NewsYearMenuTrigger .Button__icon {
    transition: transform 200ms ease;
}

.NewsYearMenuTrigger[aria-expanded='true'],
.NewsYearMenuTrigger[aria-expanded='true']:hover,
.NewsYearMenuTrigger[aria-expanded='true']:active {
    background: #e0e0e1;
}

.NewsYearMenuTrigger[aria-expanded='true'] .Button__icon {
    transform: rotate(180deg);
}

.NewsYearMenu.OverflowMenu__content {
    --overflow-menu-width: 160px;
    --overflow-menu-min-width: 160px;
    width: 160px;
    height: 188px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
}

.NewsYearMenu__check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.NewsYearMenu .OverflowMenu__checked {
    margin-left: 0;
}
`, "",{"version":3,"sources":["webpack://./pages/v2/news/index.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,+DAAuF;IACvF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAsF;IACtF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAwF;IACxF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAoF;IACpF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,+DAAyF;IACzF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["@font-face {\n    font-family: 'Open Sans';\n    src: url('../../../core/assets/fonts/OpenSans/OpenSans-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('../../../core/assets/fonts/OpenSans/OpenSans-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('../../../core/assets/fonts/OpenSans/OpenSans-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('../../../core/assets/fonts/OpenSans/OpenSans-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url('../../../core/assets/fonts/OpenSans/OpenSans-ExtraBold.ttf') format('truetype');\n    font-weight: 900;\n    font-display: swap;\n}\n\n.NewsYearMenuTrigger .Button__icon {\n    transition: transform 200ms ease;\n}\n\n.NewsYearMenuTrigger[aria-expanded='true'],\n.NewsYearMenuTrigger[aria-expanded='true']:hover,\n.NewsYearMenuTrigger[aria-expanded='true']:active {\n    background: #e0e0e1;\n}\n\n.NewsYearMenuTrigger[aria-expanded='true'] .Button__icon {\n    transform: rotate(180deg);\n}\n\n.NewsYearMenu.OverflowMenu__content {\n    --overflow-menu-width: 160px;\n    --overflow-menu-min-width: 160px;\n    width: 160px;\n    height: 188px;\n    box-sizing: border-box;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.NewsYearMenu__check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n}\n\n.NewsYearMenu .OverflowMenu__checked {\n    margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
